import { Navigate, Outlet, useLocation } from 'react-router';
import { usePortalAuth } from '../hooks/usePortalAuth';
import { PortalLayout } from '@/portal/shared/components/PortalLayout';

/**
 * Protected layout component for investor portal
 * Redirects to portal login if not authenticated
 * Wraps authenticated routes with PortalLayout and renders children via Outlet
 */
export function ProtectedPortalRoute() {
  const { isAuthenticated } = usePortalAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }

  return (
    <PortalLayout>
      <Outlet />
    </PortalLayout>
  );
}
